import { Component, OnInit } from '@angular/core';
import { DatePipe, AsyncPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { sub } from 'date-fns';
import { createCompanyNumber } from 'src/app/shared/functions';
import { EmailType, NFATypes } from 'src/app/shared/models/constants';
import { OnHandFirearm } from 'src/app/shared/models/general';

//Services
import { SharedService } from 'src/app/shared/services/shared.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: true,
    imports: [DatePipe, AsyncPipe, RouterLink]
})
export class DashboardComponent {
  on_hand_firearm_list:OnHandFirearm[] = [];
  on_hand_nfa_list:OnHandFirearm[] = [];
  isLoading: boolean = true;
  private hasReceivedBoundBookData = false;
    // {
    //   firearm_type: 'Silencer',
    //   firearm_manufacturer: 'SilencerCo',
    //   firearm_model: 'Sparrow',
    //   firearm_serial_number: '123456',
    //   firearm_caliber: '22LR',
    //   acquisition_date: '2021-01-01',
    // },
    // {
    //   firearm_type: 'Silencer',
    //   firearm_manufacturer: 'SilencerCo',
    //   firearm_model: 'Octane',
    //   firearm_serial_number: '1698745',
    //   firearm_caliber: '45',
    //   acquisition_date: '2021-09-01',
    // },
 // ]
  on_hand_firearm_count: number;
  acquired_count_last_7_days: number;
  disposed_count_last_7_days: number;
  pending_4473_count: number = 0;
  on_hand_nfa_count: number;
  pending_nfa_count: number = 0;
  submitted_3310_count_last_7_days: number = 0;
  nfa_items: string[] = NFATypes;
  company_number: string | null = null;
  constructor(
    public sharedService: SharedService,
  ) {

  }
  ngOnInit(): void {
    this.sharedService.getPending3310Records().then(() => {
      this.pending_nfa_count = this.sharedService.pending_3310_records.length;
    });
    const companyId = this.sharedService.company_info?.company_id;
    if (companyId) {
      this.sharedService.getIncompleteForm4473ByCompanyId(companyId).then(() => {
        this.pending_4473_count = this.sharedService.incomplete_4473_records.length;
      }).catch(() => {});
    }
    this.loadDashboardData();
    
    // Refresh data when the shared service retrieves the bound book
    this.sharedService.bound_book_retrieved$.subscribe(() => {
      this.hasReceivedBoundBookData = true;
      this.isLoading = false;
      this.loadDashboardData();
    });

    // Update pending count when a 3310 email is sent
    this.sharedService.email_sent$.subscribe((evt) => {
      if (evt.email_type === EmailType.form_3310) {
        this.pending_nfa_count = this.sharedService.pending_3310_records.length;
      }
    });
  }

  loadDashboardData(): void {
    // The dashboard should stop showing the overlay once bound-book loading has completed,
    // even if the result is an empty list for a new account.
    this.isLoading = !this.hasReceivedBoundBookData && this.sharedService.loading;

    this.on_hand_firearm_count = this.getOnHandFirearmCount();
    this.acquired_count_last_7_days = this.getAcquiredCountLast7Days();
    this.disposed_count_last_7_days = this.getDisposedCountLast7Days();
    this.on_hand_nfa_count = this.getOnHandNfaCount();
    this.pending_nfa_count = this.sharedService.pending_3310_records.length;
    this.pending_4473_count = this.sharedService.incomplete_4473_records.length;
    this.company_number = createCompanyNumber(this.sharedService);
    
    this.on_hand_firearm_list = [];
    this.on_hand_nfa_list = [];
    this.createOnHandFirearmList();
    this.createOnHandNfaList();
  }
  getOnHandFirearmCount(): number {
    if (!this.sharedService.bound_book) {
      return 0;
    } else if (this.sharedService.bound_book.length === 0) {
      return 0;
    }
    const count = this.sharedService.bound_book.filter(item => {
      const isNFA = this.nfa_items.some(nfa => nfa.toLowerCase() === (item.a_firearm_type || '').toLowerCase());
      return item.state !== 'Disposed' && !isNFA;
    }).length;
    return count;
  }
  getAcquiredCountLast7Days(): number {
    if (!this.sharedService.bound_book) {
      return 0;
    }
    return this.sharedService.bound_book.filter(item => item.d_date_disposed && new Date(item.d_date_disposed) >= sub(new Date(), { days: 7 })).length;
  }
  getDisposedCountLast7Days(): number {
    if (!this.sharedService.bound_book) {
      return 0;
    }
    return this.sharedService.bound_book.filter(item => item.d_date_disposed && new Date(item.d_date_disposed) >= sub(new Date(), { days: 7 })).length;
  }
  getOnHandNfaCount(): number {
    if (!this.sharedService.bound_book) {
      return 0;
    }
    const count = this.sharedService.bound_book.filter(item => {
      const isNFA = this.nfa_items.some(nfa => nfa.toLowerCase() === (item.a_firearm_type || '').toLowerCase());
      return item.state !== 'Disposed' && isNFA;
    }).length;
    return count;
  }

  createOnHandFirearmList(): void {
    for (const item of this.sharedService.bound_book) {
      const isNFA = this.nfa_items.some(nfa => nfa.toLowerCase() === (item.a_firearm_type || '').toLowerCase());
      if (item.state !== 'Disposed' && !isNFA) {
        let on_hand_firearm = new OnHandFirearm();
        on_hand_firearm.firearm_type = item.a_firearm_type;
        on_hand_firearm.firearm_manufacturer = item.a_manufacture;
        on_hand_firearm.firearm_model = item.a_model;
        on_hand_firearm.firearm_serial_number = item.a_serial_number;
        on_hand_firearm.firearm_caliber = item.a_caliber_gauge;
        on_hand_firearm.acquisition_date = item.a_date_acquired;
        this.on_hand_firearm_list.push(on_hand_firearm);
      }
    }
    this.on_hand_firearm_list = [...this.on_hand_firearm_list];
  }

  createOnHandNfaList(): void {
    for (const item of this.sharedService.bound_book) {
      const isNFA = this.nfa_items.some(nfa => nfa.toLowerCase() === (item.a_firearm_type || '').toLowerCase());
      if (item.state !== 'Disposed' && isNFA) {
        let on_hand_nfa_item = new OnHandFirearm();
        on_hand_nfa_item.firearm_type = item.a_firearm_type;
        on_hand_nfa_item.firearm_manufacturer = item.a_manufacture;
        on_hand_nfa_item.firearm_model = item.a_model;
        on_hand_nfa_item.firearm_serial_number = item.a_serial_number;
        on_hand_nfa_item.firearm_caliber = item.a_caliber_gauge;
        on_hand_nfa_item.acquisition_date = item.a_date_acquired;
        this.on_hand_nfa_list.push(on_hand_nfa_item);
      }
    }
    this.on_hand_nfa_list = [...this.on_hand_nfa_list];
  }


}
